export default __webpack_public_path__ + "static/media/recovery-icon.29300563.svg";